<template>
  <div class="lightList-content" v-loading="loading">
    <el-form ref="form" :model="pageInfo" label-width="auto" class="search_head">
      <el-row :gutter="20" class="list-head">
        <el-col :span="2">
          <el-tooltip class="item" effect="dark" content="从列表中选择设备，查询该设备连接状态" placement="bottom">
            <el-button type="primary" icon="el-icon-search" @click="findLoraState()" round>查询所选设备</el-button>
          </el-tooltip>
        </el-col>
        <el-col :span="3">
          <el-form-item label="协议类型">
            <el-select
              placeholder="选择协议类型"
              v-model="pageInfo.lamp_protocol"
              style="width: 100%"
              @change="selectChange"
            >
              <el-option
                v-for="t in protocolList"
                :key="t.id"
                :label="t.name"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="设备识别号">
            <el-input v-model="pageInfo.lamp_number" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="设备别名">
            <el-input v-model="pageInfo.lamp_name" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="选择灯组">
            <el-select
              clearable
              placeholder="请选择分灯组"
              v-model="pageInfo.lamp_group"
              style="width: 100%"
            >
              <el-option
                v-for="t in groupList"
                :key="t.id"
                :label="t.name"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
            <el-button type="primary" icon="el-icon-search" @click="headSearch" size="mini" round>检索</el-button>
            <el-button type="info" @click="headReset" size="mini" round>重置</el-button>
        </el-col>
        <el-col :span="1">
          <el-tooltip class="item" effect="dark" content="刷新列表数据" placement="bottom">
            <el-button icon="el-icon-refresh"  @click="send()" size="small" circle></el-button>
          </el-tooltip>
        </el-col>
        <el-col :span="3" class="control" v-if="pageInfo.lamp_protocol!='1'">
          <el-button type="primary" @click="allOpen.visible = true" round>全开</el-button>
          <el-button type="info"  @click="lightContorl(0)" round>全关</el-button>
        </el-col>
      </el-row>
    </el-form>
    <div class="clear"></div>
    <div class="boder-grey"></div>

    <el-table :data="tableData" style="width: 100%" :row-key="getRowKey" @selection-change="handleSelectionChange" stripe>
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="55">
      </el-table-column>
      <el-table-column
        prop="lamp_id"
        label="ID"
        align="center"
         width="60"
      ></el-table-column>
      <el-table-column
        prop="number"
        label="设备识别号"
        width="160"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="设备别名"
        width="160"
        align="center"
        stripe
      ></el-table-column>
      <!-- <el-table-column prop="address" label="地址"></el-table-column> -->
      <el-table-column
        prop="stg_name"
        label="当前策略"
        align="center"
      ></el-table-column>
      <el-table-column label="亮度控制" align="center">
        <template slot-scope="scope">
          <i
            class="el-icon-setting pointer mar-r5"
            @click="showSet(scope.row)"
          ></i>
          <span>{{ msType[scope.row.ms] }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="current"
        label="电流(A)"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="voltage"
        label="电压(V)"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="light"
        label="亮度(%)"
        align="center"
      ></el-table-column>
      <el-table-column label="倾斜角(X°/Y°)" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.is_angle">{{scope.row.x_angle}}°/{{scope.row.y_angle}}°</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="角度校正(相对/绝对)"
        prop="type"
        width="200"
        align="center"
        >
        <template slot-scope="scope">
            <el-switch
              v-model="scope.row.angle_type"
              :active-value="1"
              :inactive-value="0"
              active-color="#3ba631"
              inactive-color="#B9B9B9"
              @change="changeAngle(scope.row.lamp_id,$event)"
              v-if="scope.row.is_angle"
              />
              <span v-else>-</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="last_time" width="160" label="最后通讯时间"></el-table-column> -->
    
      <el-table-column label="查询(PWM)">
        <template slot-scope="scope">
          <el-button type="primary" @click="lightSearch(scope.row.lamp_id,4)" round>查询</el-button>
        </template>
      </el-table-column>
      <el-table-column label="查询(倾斜角)">
        <template slot-scope="scope">
          <el-button type="primary" @click="lightSearch(scope.row.lamp_id,5)" round>查询</el-button>
        </template>
      </el-table-column>
      <el-table-column label="查询(传感器)">
        <template slot-scope="scope">
          <el-button type="primary" @click="lightSearch(scope.row.lamp_id,6)" round>查询</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="edit" label="编辑" fixed="right">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="(dialogVisible = true), getLampInfo(scope.row)"
              class="el-icon-edit pointer" style="margin-right:10px;"
            ></i><i
              class="el-icon-delete pointer"
              @click="deleteLamp(scope.row.lamp_id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!-- 编辑路灯信息弹窗 -->
    <el-dialog class="dialog600" title="编辑路灯信息" :visible.sync="dialogVisible">
      <el-form
        :model="editLamp"
        label-position="left"
        label-width="80px"
        :rules="editLampRule"
        ref="lampInfo"
      >
        <el-row :gutter="20" class="item-list">
          <el-col :span="24">
            <el-form-item label="设备别名" prop="name">
              <el-input v-model="editLamp.name"></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input class="address" v-model="editLamp.address"></el-input>
            </el-form-item>
            <!-- <el-form-item label="屏幕编号" prop="screen_number">
              <el-input v-model="editLamp.screen_number"></el-input>
            </el-form-item> -->
            <el-form-item label="sim卡号" prop="sim">
              <el-input v-model="editLamp.sim"></el-input>
            </el-form-item>
            <el-form-item label="选择灯组">
              <el-select
                clearable
                placeholder="全部"
                v-model="editLamp.lamp_group"
                style="width: 100%"
              >
                <el-option
                  v-for="t in groupList"
                  :key="t.id"
                  :label="t.name"
                  :value="t.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="左边距(px)" prop="longitude">
                  <el-input v-model="editLamp.longitude" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="上边距(px)" prop="latitude">
                  <el-input v-model="editLamp.latitude"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            
          </el-col>
          
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="(dialogVisible = false), updateInfo()"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 编辑路灯亮度设置 -->
    <div
      class="box_control_bg"
      v-if="lightSetItem.lightSetVisible"
      @click="closeSet"
    ></div>
    <div class="box_control" v-if="lightSetItem.lightSetVisible">
      <div class="box_head">
        <span class="box_title">{{ lightSetItem.title }}-亮度控制</span>
        <div class="box_close" @click="closeSet">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <light-set
          ref="lightSet"
          :setData="lightSetItem.lightSetData"
          @updated="getTableData(pageInfo.page)"
        ></light-set>
      </div>
    </div>
    <!-- 全开-亮度控制 -->
    <el-dialog class="dialog600" title="全开-亮度控制" :visible.sync="allOpen.visible">
      <div class="box_body">
        <el-slider
          v-model="allOpen.light"
          :min="1"
          :max="100"
          show-input
          @change="manualChange = true"
        ></el-slider>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="allOpen.visible = false,allOpen.visible = false,allOpen.light = 0">取 消</el-button>
        <el-button type="primary" @click="(allOpen.visible = false), lightContorl(1)"
          >确 定</el-button
        >
      </div>
    </el-dialog>


  </div>
</template>

<script>
import lightListApi from "@/api/light/lightList"
import lightSet from "@/components/light/device"
import lightGroupApi from "@/api/light/lampGroup"
export default {
  components: {
    lightSet,
  },
  data() {
    const vm = this;
    return {
      loading: false,
      protocolList: [],
      groupList: [],
      lightType: ["单灯", "双灯"],
      steType: ["离线", "在线"],
      stateList:[
        {
          id: 0,
          name:"离线"
        },{
          id: 1,
          name:"在线"
        }
      ],
      steColorType: ["valuered", "valuegreen"],
      msType: ["(自动)", "(手动)"],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
        stg_id:'', //策略
        lamp_protocol: '1', //协议
        lamp_group: '', //灯组
        lamp_number: '', //编号
        lamp_name: '',//名称
        ste: ''//名称
      },
      cnt_all: 0,
      dialogVisible: false,
      lightSetItem: {
        lightSetVisible: false,
        title: "",
        lightSetData: {},
      },
      editLamp: {},
      editLampRule: {
        name: [{ required: false, message: "请输路灯名", trigger: "blur" }],
        address: [{ required: false, message: "请输入地址", trigger: "blur" }],
      },
      path: "wss://lora.taiott.com/message",
      multipleSelection: [],
      manualChange: false,
      allOpen: {
        visible: false,
        light: 0
      }
    };
  },
  methods: {
    getProtocolList() { // 获取协议列表
      lightListApi.getLampProtocol().then((res) => {
        if (res.data.code === 1000) {
          this.protocolList = res.data.data;
          if(this.protocolList.length>0){
            this.pageInfo.lamp_protocol = this.protocolList[0].id
          }
          this.getGroupList()
          this.getTableData(this.pageInfo.page);
        }
      });
    },
    getGroupList() { // 获取灯组列表
      lightGroupApi.lightGroupList({
        page: 1,
        pageSize: 200,
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.groupList = resData.list;
        }
      });
    },
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      lightListApi.lightList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    checkProtocel() {
      this.pageInfo = {
        page: 1,
        pageSize: 20,
        type: this.pageInfo.lamp_protocol
      }
      this.getTableData(this.pageInfo.page)
    },
    lightContorl (light) {
      if(light==1){
        light=this.allOpen.light
      }
      let sendData = {
        light: light,
        type: this.pageInfo.lamp_protocol,
      }
      // console.log('sendData',sendData)
      // return
      lightListApi.lightControl(0,sendData).then(res => {
        if (res.data.code === 1000) {
          this.$message.success('下发成功')
        }
      })
    },
    lightSearch (lamp_id,type) {

      let sendData = {
        // light: light,
        type: type,
      }
      // console.log('sendData',sendData)
      // return
      lightListApi.lightControl(lamp_id,sendData).then(res => {
        if (res.data.code === 1000) {
          this.$message.success('下发成功')
        }
      })
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    getLampInfo(row) {
      // console.log('row',row)
      this.editLamp = row;
    },
    deleteLamp(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          lightListApi.lightDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    updateInfo() {
      let postData = {
        name: this.editLamp.name,
        address: this.editLamp.address,
        sim: this.editLamp.sim,
        screen_number: this.editLamp.screen_number,
        lamp_group: this.editLamp.lamp_group,
        ste: this.editLamp.ste,
        longitude: this.editLamp.longitude,
        latitude: this.editLamp.latitude
      };

      lightListApi.lightEdit(this.editLamp.lamp_id, postData).then((res) => {
        if (res.data.code === 1000) {
          console.log("lightEdit", res);
          this.$message({
            message: "更改成功",
            type: "success",
          });
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
    showSet(setting) {
      let query_data = {
        lamp_id: parseInt(setting.lamp_id),
        type: this.pageInfo.lamp_protocol,
        name: setting.name,
        stg_name: setting.stg_name,
        light: parseInt(setting.light),
        stg_id: parseInt(setting.stg_id),
        ms: parseInt(setting.ms),
      };
      this.lightSetItem.lightSetVisible = true;
      this.lightSetItem.title = setting.name;
      this.lightSetItem.lightSetData = query_data;
    },
    closeSet() {
      // 关闭编辑亮度
      let query_data = {
        id: "",
        name: "",
        stg_name: "",
        light: "",
        stg_id: "",
        ms: "",
      };
      this.lightSetItem.lightSetVisible = false;
      this.lightSetItem.title = "";
      this.lightSetItem.lightSetData = query_data;
      this.getTableData(this.pageInfo.page);
    },

    changeSetHome(id, value) { //设置首页显示
      lightListApi.lightSetHome(id,{ type: value }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("设置成功");
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    },
    headReset() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.pageInfo.stg_id = ''
      this.pageInfo.lamp_protocol = this.protocolList[0].id
      this.pageInfo.lamp_group = ''
      this.pageInfo.ste = ''
      this.pageInfo.lamp_number = ''
      this.pageInfo.lamp_name = ''
      this.getTableData(1)
    },
    selectChange(value) {
      if (value) {
        this.getTableData(this.pageInfo.page);
      } else {
        return value;
      }
    },

    getRowKey (row) {
      return row.lamp_id
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      
    },
    findLoraState(){ //查询所选中的设备
      let selVal = this.multipleSelection
      if(selVal.length<1||selVal.length>20){
        this.$message.error('请选择1-20个设备');
      }
      let mulVal= '';
      for(let i=0; i<selVal.length; i++){
        mulVal=mulVal+selVal[i].lamp_id+','
      }
      mulVal=mulVal.slice(0,mulVal.length-1)
      lightListApi.lightFindLora({ lamp_ids: mulVal }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("查询成功");
        } else {
          this.$message.error(res.data.message);
        }
      });
    }, 
    
    changeAngle(id, value) { //设置倾斜角
      lightListApi.lightSetAngle(id,{ angle: value }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("设置成功");
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
  created() {
    this.getProtocolList()

  },
  destroyed() {
    // 销毁监听
    this.socket.onclose = this.close;
  }
};
</script>
<style lang='less' scoped>
.lightList-content {
  width: 100%;

  .lamp-refresh {
    top: -10px;
  }
  .valuegreen {
    display: inline-block;
    width: 8px;
    height: 8px;
    background: rgba(26, 151, 14, 0.856);
    border-radius: 50%;
    margin-right: 5px;
  }
  .valuered {
    display: inline-block;
    width: 8px;
    height: 8px;
    background: rgba(241, 12, 4, 0.856);
    border-radius: 50%;
    margin-right: 5px;
  }
  .map-container {
    width: 100%;
    height: 292px;
    /* margin-bottom: 20px; */
  }

  .icon-error {
    background: url(/static/images/icons/error.png);
    display: inline-block;
    width: 20px;
    height: 20px;
    background-size: cover;
  }
}
.box_control {
  width: 600px !important;
  height: auto !important;
  margin-top: -200px !important;
  margin-left: -300px !important;
  .box_body {
    padding-bottom: 25px;
  }
}
.control{
  text-align: right;
}
</style>